// extracted by mini-css-extract-plugin
export default {"boxShadow":"Home_boxShadow__i6Uds","boxShadow2":"Home_boxShadow2__LGFbC","bgcolor":"Home_bgcolor__2SOhu"};